import { cn } from "../../lib/utils";
import ModalContainer from "./ModalContainer";
import SectionBox from "../../components/section-box/SectionBox";
import { PlanHierarchyIcon } from "../plans/PlanHierarchyIcon";
import "./ConfirmPlansFixModal.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

export const ConfirmPlansFixModal = ({
	open,
	setOpen,
	organization,
	onConfirm = () => {},
	onCancel,
	isLoading,
}) => {
	return (
		<ModalContainer isOpen={open} setIsOpen={setOpen}>
			<div className={"main_modal_content confirm_plans_fix_popup"}>
				<button
					className="main_close"
					onClick={() => setOpen(false)}
					type="button"
					aria-label="Chiudi"
				>
					<span className="icon_10 default close icon_mask !bg-white"></span>
				</button>

				<div className="main_header_modal left_text">
					<div className="title">Abilita piano sull'ente</div>
					<div className={"flex flex-col gap-2"}>
						<div className="main_subtitle">
							<div className="main_icon">
								<span className={"icon_16 default entity icon_mask !bg-dark-70"}></span>
							</div>
							<span className="subtitle">Organizzazione</span>
						</div>
						<div>{organization?.name}</div>
					</div>
				</div>

				{/* Modal Content */}
				<div className={"main_body_modal !p-0"}>
					<OverlayScrollbarsComponent
						defer
						options={{ scrollbars: { autoHide: "scroll" } }}
						className="[&>div]:flex [&>div]:flex-col [&>div]:gap-7 max-h-[calc(85vh-200px)] p-7"
					>
						{/* Alert */}
						<div className="main_alert_message info_alert !mt-0">
							<div className="main_icon">
								<span className="icon_16 default wrench icon_mask !bg-interactive-100"></span>
							</div>
							<div className="message">
								<div className={"font-semibold text-sm"}>
									Le informazioni dell’ente richiedono di un piccolo fix
								</div>
								<div className={"text-xs text-dark-70"}>
									Saranno associati automaticamente anche i seguenti piani per mantenere le
									informazioni completamente aggiornate.
								</div>
							</div>
						</div>

						{/* Issues */}
						<div className={"flex flex-col gap-5"}>
							<div className={"text-dark-60 uppercase font-bold text-[16px]"}>
								Piani: {organization?.template_plan_activation?.missing_template_plans?.length}
							</div>
							<div className={"flex flex-col gap-5"}>
								{organization?.template_plan_activation?.missing_template_plans?.map(
									(plan, indexPlan) => (
										<SectionBox
											className={{ content: "!p-5 flex items-center gap-4" }}
											key={indexPlan}
										>
											<div className={"flex-none"}>
												<PlanHierarchyIcon level={"branch"} />
											</div>
											<div className={"flex-1"}>
												<div className={"line-clamp-1"}>{plan?.name ?? "-"}</div>
												<div className={"line-clamp-1 text-sm text-dark-70"}>
													{plan?.description ?? "-"}
												</div>
											</div>
										</SectionBox>
									)
								)}
							</div>
						</div>
					</OverlayScrollbarsComponent>
				</div>

				<div className="main_footer_modal">
					<button
						type="button"
						onClick={() => (onCancel ? onCancel() : setOpen(false))}
						className="button line"
					>
						Annulla
					</button>

					<button
						type="button"
						onClick={onConfirm}
						className={cn("button fill success", isLoading && "loading")}
					>
						<div className="load_content">{"Conferma"}</div>
						<div className="main_loader_icon fade_in"></div>
					</button>
				</div>
			</div>
		</ModalContainer>
	);
};
